import { Injectable } from '@angular/core';
import { CognitoIdentityServiceProvider } from 'aws-sdk';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserPoolService {
  private readonly cognito = new CognitoIdentityServiceProvider({
    region: 'us-east-1',
    credentials: {
      accessKeyId: 'AKIA3ITLEVL4SUCPY25D',
      secretAccessKey: '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',
    },
  });

  private readonly userPools: Record<string, { poolId: string; clientId: string }> = {
    dev: { poolId: 'us-east-1_7DewIM4H9', clientId: '3fia4gggkishj54q8366n8q7ev' },
    test: { poolId: 'us-east-1_xg0xyXVhd', clientId: '609eil4molccu2clhd17gasv0v' },
    prod: { poolId: 'us-east-1_82nRerunH', clientId: '32hkfas55s3qs9454v719bh5cg' },
  };

  constructor() {}

  private getPoolId(): string {
    const stage = environment.stage ?? 'dev';
    return this.userPools[stage]?.poolId ?? this.userPools['dev'].poolId;
  }

  /**
   * Obtiene todos los usuarios (o uno específico) de un pool según el stage actual.
   * @param email opcional: si se pasa, devuelve solo ese usuario
   */
  async getUsers(email?: string): Promise<any[]> {
    try {
      const poolId = this.getPoolId();
      const users = await this.cognito
        .listUsers({ UserPoolId: poolId })
        .promise();

      if (!users.Users) return [];

      const parsedUsers = users.Users.map((user) => {
        const attrs: Record<string, string> = {};
        user.Attributes?.forEach((attr) => {
          attrs[attr.Name] = attr.Value ?? '';
        });
        return {
          username: user.Username,
          email: attrs['email'] ?? '',
          attributes: attrs,
        };
      });

      if (email) {
        return parsedUsers.filter((u) => u.email === email);
      }

      return parsedUsers;
    } catch (err) {
      console.error('Error al obtener usuarios del pool:', err);
      return [];
    }
  }
}
